import { Component, inject, OnInit } from '@angular/core';
import { ContainerComponent } from '../../core/components/block/container/container.component';
import { BreadCrumbsComponent } from '../../core/components/ui/bread-crumbs/bread-crumbs.component';
import { FiltersComponent } from '../../core/components/block/fitlers/filters.component';
import { BreadCrumbService } from '../../core/services/bread-crumb.service';
import { IBreadCrumb } from '../../core/interface/bread-crumb';
import { AnnouncementListComponent } from '../../core/components/block/announcement-list/announcement-list.component';
import { PageModel } from '../../core/models/page.models';
import { ActivatedRoute } from '@angular/router';
import { NewsListComponent } from '../../core/components/block/news-list/news-list.component';

@Component({
  selector: 'app-news',
  imports: [
    ContainerComponent,
    BreadCrumbsComponent,
    FiltersComponent,
    AnnouncementListComponent,
    NewsListComponent,
  ],
  templateUrl: './news.component.html',
  standalone: true,
  styleUrl: './news.component.scss',
})
export class NewsComponent implements OnInit {
  private breadCrumbService = inject(BreadCrumbService);
  private route = inject(ActivatedRoute);

  page: PageModel | null = null;

  get breadCrumbs(): IBreadCrumb[] {
    return [
      { labels: ['Головна'], to: '/' },
      {
        labels: [this.page?.translation?.data?.title],

        to: '/news',
      },
    ];
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.page = data['page'];
      this.breadCrumbService.breadCrumbs.set(this.breadCrumbs);
    });
  }
}
